export enum STATUS_TYPES {
  STATUS_IDLE= "STATUS_IDLE",
  STATUS_LOADING= "STATUS_LOADING",
  STATUS_SUCCESS= "STATUS_SUCCESS",
  STATUS_ERROR= "STATUS_ERROR",
}
